<form [formGroup]="empListSubHeaderForm">
  <div class="expanded-row-filter sdps-p-bottom_medium">
    <div *ngFor="let col of empAccSubHeaderCols">
      <!-- Header section of the employees/participants sub-header -->
      <div class="timePickerForm sdps-p-left_small sdps-p-bottom_small sdps-p-top_small">
        <span *ngIf="col.header !== 'Show Records'" id="{{col.field}}">{{col.header || 'Filter'}}</span>
        <span id="{{col.field}}" *ngIf="col.header === 'Show Records' && sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageRule.uuid,'','')">
          {{col.header || 'Show Records'}}
        </span>
      </div>

      <!-- Group/Plan Name dropdown -->
      <div  class="timePickerForm on-scroll emtr-dropdown mutual-fund-asset-group-dropdown group-plan-name-dropdown sdps-p-left_small"
         *ngIf="col.enum === 'dropdown' && col.field === 'empGroupName' && getOrgId && sharedService.businessUnit">
        <label class="sr-only" for="filterInput_EmpGroupName">{{(col.header || 'Group or Plan Name') + ' filter'}}</label>
        <ems-lazy-load-dropdown #groupPlanDropdown [id]="'manage_Employee_' + col.field"
          [name]="col.field" [orgID]="getOrgId" [dropdownName]="'groupName'"
          [businessUnit]="sharedService.businessUnit" [ariaLabel]="(col.header || 'Group or Plan Name') + ' filter'"
          (ngModelGroupChange)="groupNameUpdated($event)"
          (updateGroupOrPlanName)="applyPersistedGroupPlanSelection()"></ems-lazy-load-dropdown>
      </div>


      <!-- Show Records dropdown -->
      <div class="timePickerForm emtr-dropdown sdps-p-left_small sdps-p-right_small show-records" *ngIf="col.field === 'showRecords' && col.enum === 'dropdown' && sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageRule.uuid,'','')">
        <label class="sr-only" for="manage_Employee_{{col.field}}">Records per page</label>
        <p-select inputId="manage_Employee_{{col.field}}" aria-label="Records per page" optionLabel="label" formControlName="{{col.field}}"
                    [options]="sharedConstant.showRecords">
        </p-select>
      </div>
    </div>
  </div>
</form>
